import { render, staticRenderFns } from "./LanguagesCard.vue?vue&type=template&id=1ff1363d&"
import script from "./LanguagesCard.vue?vue&type=script&lang=js&"
export * from "./LanguagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff1363d')) {
      api.createRecord('1ff1363d', component.options)
    } else {
      api.reload('1ff1363d', component.options)
    }
    module.hot.accept("./LanguagesCard.vue?vue&type=template&id=1ff1363d&", function () {
      api.rerender('1ff1363d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/LanguagesCard.vue"
export default component.exports